import { jsxs as e, jsx as t } from "react/jsx-runtime";

import { memo as r, useContext as a, useCallback as i, createContext as n, useRef as s, useEffect as o, useLayoutEffect as l } from "react";

import { useSyncExternalStore as c } from "use-sync-external-store/shim";

import d from "./model/index.js";

import m from "@ui-components-3/icons/lib/duotone/CaretUp";

import p from "@ui-components-3/icons/lib/duotone/CaretDown";

import u from "../../utils/classNames/index.js";

const h = {
    primary: {
        activeGroupBg: "bg-primary-100",
        activeChildBg: "bg-primary-200",
        activeText: "text-primary-600",
        stripe: "bg-primary-600"
    },
    secondary: {
        activeGroupBg: "bg-secondary-100",
        activeChildBg: "bg-secondary-200",
        activeText: "text-secondary-700",
        stripe: "bg-secondary-700"
    }
}, v = r((({item: r, depth: n, variant: s}) => {
    const o = a(x), l = c(o.subscribe, i((() => o.isActive(r)), [ r ])), d = i((e => o.el(r, n, e)), [ r, n ]);
    if (r.hidden?.()) return null;
    const {path: v, label: g, Icon: b, ActiveIcon: y, renderLabel: w, testId: N, children: B} = r, {Link: C} = o, P = B && (l ? p : m), T = l && y || b, {activeChildBg: j, activeText: G} = h[s];
    return e("li", {
        ref: d,
        children: [ e(C, {
            to: v,
            "data-testid": N,
            "aria-current": !!l && "page",
            className: u("gap-s p-s flex items-center", n || l ? "" : "group hover:bg-neutral-100", l ? u(G, n ? j : "") : "text-neutral-500"),
            children: [ T && t(T, {
                "aria-hidden": "true",
                className: "w-m transition-transform duration-300 group-hover:scale-110"
            }), w ? w() : g, P && t(P, {
                className: "ml-s",
                "aria-hidden": "true"
            }) ]
        }), B && f(B, n + 1, l, s) ]
    });
})), f = (e, r, a, i) => t("ul", {
    className: u("flex list-none flex-col transition-[width,height]", a ? r ? h[i].activeGroupBg : "" : "h-0 w-0 overflow-hidden"),
    children: e.map((e => t(v, {
        item: e,
        variant: i,
        depth: r
    }, e.path)))
}), g = ({variant: e}) => {
    const r = a(x), i = c(r.subscribe, (() => r.activeElement));
    return t("div", {
        "aria-hidden": "true",
        className: u("absolute left-0 top-0 w-[4px] rounded-full transition-[transform,width,height]", h[e].stripe, i ? "" : "h-0"),
        style: i ? {
            transform: `translateY(${i.offsetTop}px)`,
            height: i.offsetHeight
        } : void 0
    });
}, x = n({}), b = ({usePathname: e}) => {
    const t = a(x);
    return e(), l((() => t.updatePath())), null;
}, y = r((({className: r, items: a, usePathname: i, Link: n, variant: l = "primary"}) => {
    const c = s().current ||= new d(n);
    return o((() => () => c.destroy()), []), e(x.Provider, {
        value: c,
        children: [ t(b, {
            usePathname: i
        }), e("nav", {
            className: u("typography-body-xl pl-xxs relative font-semibold text-neutral-500", r),
            children: [ t(g, {
                variant: l
            }), f(a, 0, !0, l) ]
        }) ]
    });
}));

export { y as default };
//# sourceMappingURL=index.js.map
